<template>
  <b-card no-body class="border mb-2">
    <b-card-body>
      <div class="d-flex justify-content-between align-items-start mb-1">
        <div>
          <h5 class="mb-0">Traffic</h5>
          <small class="text-muted">
            Successful vs failed calls per {{ granularityLabel }}
          </small>
        </div>
      </div>

      <div v-if="!hasData" class="text-center text-muted py-4">
        No traffic in this window.
      </div>

      <vue-apex-charts
        v-else
        type="area"
        height="280"
        width="100%"
        :options="chartOptions"
        :series="series"
      />
    </b-card-body>
  </b-card>
</template>

<script>
import { BCard, BCardBody } from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import { bucketLabel } from './usageFormat'

export default {
  name: 'UsageTimeseriesChart',
  components: {
    BCard,
    BCardBody,
    VueApexCharts,
  },
  props: {
    timeseries: {
      type: Object,
      default: () => ({ granularity: 'hour', points: [] }),
    },
  },
  computed: {
    points() {
      return this.timeseries?.points || []
    },
    hasData() {
      return this.points.some(point => point.requests > 0)
    },
    granularityLabel() {
      return this.timeseries?.granularity === 'day' ? 'day' : 'hour'
    },
    series() {
      return [
        {
          name: 'Succeeded',
          data: this.points.map(point => point.success || 0),
        },
        {
          name: 'Failed',
          data: this.points.map(
            point => (point.client_errors || 0) + (point.server_errors || 0),
          ),
        },
      ]
    },
    chartOptions() {
      const granularity = this.timeseries?.granularity
      const labels = this.points.map(point => bucketLabel(point.timestamp, granularity))

      return {
        chart: {
          stacked: true,
          toolbar: { show: false },
          type: 'area',
        },
        colors: ['#28c76f', '#ea5455'],
        dataLabels: { enabled: false },
        stroke: { curve: 'smooth', width: 2 },
        fill: { type: 'gradient', gradient: { opacityFrom: 0.5, opacityTo: 0.05 } },
        legend: { position: 'top', horizontalAlign: 'right' },
        grid: { borderColor: '#ebe9f1', strokeDashArray: 4 },
        xaxis: {
          categories: labels,
          // A 90-day window would otherwise print 90 overlapping labels.
          tickAmount: Math.min(labels.length, 12),
          labels: { rotate: 0, hideOverlappingLabels: true },
        },
        yaxis: { labels: { formatter: value => Math.round(value) } },
        tooltip: { shared: true, intersect: false },
      }
    },
  },
}
</script>
